import { ContentWidthEnum } from 'common/types/styleTypes'
import React, { ReactNode } from 'react'
import { WebsitePageBodyContainer } from 'src/shared/entities/website-page-body/ui/website-page-body-container'
import { WebsitePageBodyWrapper } from 'src/shared/entities/website-page-body/ui/website-page-body-wrapper'

export interface CommonWebsitePageBodyProps {
  htmlAttrId: string
  children: ReactNode
  contentWidth: ContentWidthEnum | undefined
  pageBackground: string | undefined
  pageMobileBackground?: string | undefined
  background: string | undefined
  mobileBackground?: string | undefined
  backgroundImage: string
  mobileBackgroundImage?: string
}

export const CommonWebsitePageBody = ({
  htmlAttrId,
  children,
  contentWidth = ContentWidthEnum.m,
  background,
  mobileBackground,
  backgroundImage,
  mobileBackgroundImage,
  pageBackground,
  pageMobileBackground,
}: CommonWebsitePageBodyProps) => {
  return (
    <WebsitePageBodyWrapper
      id={htmlAttrId}
      background={pageBackground}
      mobileBackground={pageMobileBackground}
    >
      <WebsitePageBodyContainer
        contentWidth={contentWidth}
        background={background}
        mobileBackground={mobileBackground}
        backgroundImage={backgroundImage}
        mobileBackgroundImage={mobileBackgroundImage}
      >
        {children}
      </WebsitePageBodyContainer>
    </WebsitePageBodyWrapper>
  )
}
